import { useRouter } from 'next/router';
import { extractConsultantSlug } from 'utils/extractConsultantSlug';
import { useCustomerConsultant } from './useCustomerConsultant';

export function useOrganisationPersonalWebshop() {
    const { asPath } = useRouter();
    const { slug } = useCustomerConsultant();

    const { language, consultantSlug, isConsultantRoute } = extractConsultantSlug(asPath);

    const rootUrl = language ? `/${language}` : '';

    if (slug) {
        return {
            isConsultantRoute: true,
            organisationPersonalWebshopSlug: slug,
            baseUrl: `${rootUrl}/consultant/${slug}`,
            rootUrl,
        };
    }

    return {
        isConsultantRoute,
        organisationPersonalWebshopSlug: isConsultantRoute ? consultantSlug : '',
        baseUrl: isConsultantRoute ? `${rootUrl}/consultant/${consultantSlug}` : rootUrl,
        rootUrl: '',
    };
}
